import '../plugins/stickyScrollBlockPlugin';
import '../utils/responsiveHelper';

// initialize fixed blocks on scroll
export default function initStickyScrollBlock() {
  let headerHeight = 0;

  if (window.innerWidth >= 1024) {
    headerHeight = $('.header').height() + 60;
  };

  window.ResponsiveHelper.addRange({
		'..1279': {
			on: () => {
				jQuery('.offers-section .section-top').stickyScrollBlock({
          setBoxHeight: true,
          activeClass: 'fixed-position',
          container: '.offers-section .inner-content-wrapper',
          positionType: 'fixed',
          extraTop: function() {
						var totalHeight = 0;
						jQuery('0').each(function() {
							totalHeight += jQuery(this).outerHeight();
						});
						return totalHeight;
					},
					extraBottom: 250
        });
			},
			off: () => {
				jQuery('.offers-section .section-top').stickyScrollBlock('destroy');
			}
		}
	});

  window.ResponsiveHelper.addRange({
		'1280..': {
			on: () => {
				jQuery('.offers-table-wrap.main-table .offers-table-wrap').stickyScrollBlock({
          setBoxHeight: false,
          activeClass: 'fixed-position',
          container: '.offers-table-wrap.main-table',
          positionType: 'fixed',
          extraTop: headerHeight,
          extraBottom: 200
        });
        jQuery('.offers-section .section-top').stickyScrollBlock({
          setBoxHeight: true,
          activeClass: 'fixed-position',
          container: '.offers-section .inner-content-wrapper',
          positionType: 'fixed',
          extraTop: headerHeight,
          extraBottom: 0
        });
			},
			off: () => {
				jQuery('.offers-table-wrap.main-table .offers-table-wrap').stickyScrollBlock('destroy');
        jQuery('.offers-section .section-top').stickyScrollBlock('destroy');
			}
		}
	});
};
